import {observer} from 'mobx-react';
import {withState, warnUnsavedChanges} from 'shared/core';
import OfferTemplateEditorState from '../state/OfferTemplateEditorState';
import {AutosaveStatus, Layout, Display} from 'shared/components';
import {ModalButtons} from 'shared/components/modals';
import OfferTemplateForm from './OfferTemplateForm';

const OfferTemplateEditor = observer(({uiState}) => {
  const {template} = uiState;

  return (
    <div>
      <Display backPath='/offer_templates' />
      <Layout>
        <OfferTemplateForm uiState={uiState} />
        <ModalButtons
          onSave={() => uiState.saveTemplate()}
          onCancel={() => uiState.goBack()}
        >
          <AutosaveStatus autosaver={template.autosaver} className='mr2'/>
        </ModalButtons>
      </Layout>
    </div>
  );
});

export default warnUnsavedChanges(withState(OfferTemplateEditor, OfferTemplateEditorState));
